import { useState, useEffect, useCallback } from "react";
import styles from "../tablesStyle/RefundSection.module.css";
import WarehouseModal from "./customComponentsTable/WarehouseModal";
import ReturnCreatePanel from "./customComponentsTable/ReturnCreatePanel";
import CustomSelect from "../../customComponents/CustomSelect";
import { API_URL } from "../../config/api";

const RefundSection = () => {
  const [Select, setSelect] = useState("");
  const [refundData, setRefundData] = useState([]);
  const [storages, setStorages] = useState([]);
  const [isWarehouseModalOpen, setIsWarehouseModalOpen] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const token = localStorage.getItem("token");

  const [suppliers, setSuppliers] = useState([]);
  const [selectedRefund, setSelectedRefund] = useState(null);

  // функция при клике на строку
  const handleRowClick = (refund) => {
    setSelectedRefund(refund);
    setIsPanelOpen(true);
  };

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const res = await fetch("/api/contractors?type=supplier", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const json = await res.json();
        if (!res.ok) throw new Error("Ошибка загрузки поставщиков");

        setSuppliers(json.data);
      } catch (err) {
        console.error("Ошибка GET suppliers:", err);
      }
    };

    if (token) fetchSuppliers();
  }, [token]);

  useEffect(() => {
    const fetchStorages = async () => {
      try {
        const res = await fetch(`${API_URL}/api/storages`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const json = await res.json();
        if (!res.ok) throw new Error("Ошибка загрузки складов");

        setStorages(json.data);
      } catch (err) {
        console.error("Ошибка GET storages:", err);
      }
    };

    if (token) fetchStorages();
  }, [token]);

  // ✅ ESLint fix: useCallback чтобы fetchRefunds был стабильным + deps
  const fetchRefunds = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/api/stock_changes?type=return`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const json = await res.json();
      if (!res.ok) throw new Error("Ошибка загрузки данных");

      const mapped = (json.data || []).map((item) => ({
        id: item.id,
        documentNumber: item.name,
        date: item.inserted_at?.split("T")[0],
        provider: item.contractor_id || "—",
        sum: item.amount,
        storage: item.storage_id,
        employee: "—",
        comment: item.aux?.comment,
      }));

      setRefundData(mapped);
    } catch (err) {
      console.error("Ошибка GET refunds:", err);
    }
  }, [token]);

  // вызываем её в useEffect для загрузки при монтировании
  useEffect(() => {
    if (token) fetchRefunds();
  }, [token, fetchRefunds]);

  const refundWithStorageNames = refundData.map((item) => {
    const store = storages.find((s) => s.id === item.storage);
    const supplier = suppliers.find((s) => s.id === item.provider);

    return {
      ...item,
      storageName: store ? store.name : "—",
      providerName: supplier ? supplier.name : "—",
    };
  });

  const openWarehouseModal = () => {
    setIsWarehouseModalOpen(true);
  };

  const closeWarehouseModal = () => {
    setIsWarehouseModalOpen(false);
  };

  const handleSelectWarehouse = (warehouse) => {
    setSelectedWarehouse({
      id: warehouse.id,
      name: warehouse.name,
    });

    closeWarehouseModal();
    setIsPanelOpen(true);
  };

  return (
    <div className={styles.container}>
      <button className={styles.add} onClick={openWarehouseModal}>
        +
      </button>

      <WarehouseModal
        isOpen={isWarehouseModalOpen}
        onClose={closeWarehouseModal}
        onSelect={handleSelectWarehouse}
      />

      {isPanelOpen && (selectedRefund || selectedWarehouse) && (
        <ReturnCreatePanel
          refundId={selectedRefund ? selectedRefund.id : null}
          warehouse={
            selectedRefund
              ? { id: selectedRefund.storage, name: selectedRefund.storageName }
              : selectedWarehouse
          }
          supplier={
            selectedRefund
              ? { id: selectedRefund.provider, name: selectedRefund.providerName }
              : null
          }
          onClose={() => {
            setIsPanelOpen(false);
            setSelectedRefund(null);
            setSelectedWarehouse(null);
          }}
          onSuccess={fetchRefunds}
        />
      )}

      <div className={styles.SelectBox}>
        <CustomSelect
          className={styles.filters__select}
          options={["Select 1"]}
          value={Select}
          onChange={setSelect}
          placeholder="Select"
        />
        <CustomSelect
          className={styles.filters__select}
          options={["Select 1"]}
          value={Select}
          onChange={setSelect}
          placeholder="Select"
        />
        <input type="date" name="date" className={styles.date} />
        <CustomSelect
          className={styles.filters__select}
          options={["Select 1"]}
          value={Select}
          onChange={setSelect}
          placeholder="Select"
        />
        <CustomSelect
          className={styles.filters__select}
          options={["Select 1"]}
          value={Select}
          onChange={setSelect}
          placeholder="Select"
        />
      </div>

      {/* Таблица */}
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Номер документа</th>
            <th>Дата</th>
            <th>Поставщик</th>
            <th>Сумма</th>
            <th>Склад</th>
            <th>Сотрудник</th>
            <th>Комментарий</th>
          </tr>
        </thead>

        <tbody>
          {refundWithStorageNames.length === 0 ? (
            <tr>
              <td colSpan="7" className={styles.empty}>
                Здесь пусто
              </td>
            </tr>
          ) : (
            refundWithStorageNames.map((item) => (
              <tr
                key={item.id}
                onClick={() => handleRowClick(item)}
                style={{ cursor: "pointer" }}
              >
                <td>{item.documentNumber}</td>
                <td>{item.date}</td>
                <td>{item.providerName}</td>
                <td>{item.sum}</td>
                <td>{item.storageName}</td>
                <td>{item.employee}</td>
                <td>{item.comment}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RefundSection;
